import * as FleetModule from 'Modules/FleetModule';
import * as AlertModule from 'Modules/AlertModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as TIModule from 'Modules/TerminalInstallationModule';
import * as Dictionary from 'Models/Dictionary';
import * as React from 'react';
import ReactTable, {ReactTableDefaults, TableProps} from 'react-table';
import i18n from './../Translations/_i18n';
import moment from 'moment';
import {WithTranslation, withTranslation} from 'react-i18next';
import {CustomSort} from 'components/Map/VehiclesList/CustomFilterComponents';
import {TooltipFiltering} from 'components/Layout/Form/Fields/CustomFilterComponents';
import {EnumTypes} from "Models/EnumTypes/TerminalInstallationEnumTypes";
import {Types} from "Modules/ContractModule";
import {ActiveType} from "Models/EnumTypes/ContractEnumTypes";
import {Link} from "react-router-dom";
import { EnumTypes as PageEnumTypes } from 'Models/EnumTypes/PageEnumTypes'
import {DEFAULT_PAGE_SIZE_FOR_HISTORY} from "../constants";
import {LegacyRef} from "react";

Object.assign(ReactTableDefaults, {
    nextText: i18n.t(`tables:${'nextText'}`),
    pageText: i18n.t(`tables:${'pageText'}`),
    previousText: i18n.t(`tables:${'previousText'}`),
    loadingText: i18n.t(`tables:${'loading'}`),
    rowsText: i18n.t(`tables:${'rowsText'}`),
    noDataText: i18n.t(`tables:${'noDataText'}`),
    showPageSizeOptions: false,
    manual: true,
    filterable: true,
    defaultPageSize: 25,
    // pageSize: 25,
    showPagination: false
});

export const injectThProps = (state, rowInfo, column) => {
    if (column?.Header === 'hiddenHeader') {
        return {
            style: {display: 'none'}
        };
    }
    return {};
};

export function convertHeadingIntoText(heading: number) {
    if (heading === null) {
        return null
    }
    const val = Math.floor(heading / 22.5 + 0.5);
    const arr = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    return arr[val % 16] || null;
}

export function checkPageQuery(arr: Array<{ id: any; value: any }> = [], currentPage: number = 0, itemsPerLoad: number = 50, firstLoad: number = 0) {
    const currentPageSign = Math.sign(currentPage);
    const firstValue = firstLoad === 0 ? currentPage * itemsPerLoad : firstLoad * currentPageSign + (currentPage - currentPageSign) * itemsPerLoad;
    //const maxValue = currentPage > 0 ? firstValue + itemsPerLoad : firstLoad || itemsPerLoad;
    const maxValue = currentPage > 0 ? itemsPerLoad : firstLoad || itemsPerLoad;

    const firstIdx = arr.findIndex(e => e.id === 'first');
    const maxIdx = arr.findIndex(e => e.id === 'max');
    if (firstIdx !== -1) {
        arr[firstIdx].value = firstValue;
    } else {
        arr.push({
            id: 'first',
            value: firstValue
        });
    }
    if (maxIdx !== -1) {
        arr[maxIdx].value = maxValue;
    } else {
        arr.push({
            id: 'max',
            value: maxValue
        });
    }
    return arr;
}

interface IFleetCarBlock {
  fleetDto: FleetModule.Types.CarFleetDto
  hasAccessToDiagnostic?: boolean
  onClick?: (id: string | number) => Promise<void>
}
export const FleetCarBlock = (props: IFleetCarBlock) => {
    const {fleetDto, hasAccessToDiagnostic, onClick} = props;

    return (
        <div className="fleetCarBlock">
            <div className="fleetCarBlock__wrapper">
                {fleetDto?.cars.map((car, i) => (
                    <SingleCarSubComponent
                      key={car.deviceId}
                      car={car}
                      link={hasAccessToDiagnostic
                        ? `${Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)}?search-car-id=${car.id}`
                        : `${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/${car.id}/diagnostic`
                      }
                      onClick={onClick}
                    />
                ))}
                {fleetDto?.cars.length === 0 && (
                    <div className="fleetCarBlock__single">
                        <p className="bold">Brak pojazdów w wybranej flocie.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export const ShortCarDescription = ({ car }: { car: VehiclesModule.Types.CarDto }) => (
    <>
        <img src={Dictionary.CarCategoryTableFilters.get(car.carCategory)} alt=""/>
        <span>
            {car.name || car.model}, {car.licensePlate} (VIN: {car.vin} ID:{car.deviceId})
        </span>
    </>
)

interface ISingleCarSubComponent {
  car: VehiclesModule.Types.CarDto
  onClick?: (id: string | number) => Promise<void>
  link?: string
}

export const SingleCarSubComponent = (props: ISingleCarSubComponent) => {
    const {
        car,
        onClick,
        link
    } = props;
    return (
        <div className="fleetCarBlock__single">
            {link
                ? (
                    <Link
                        to={link}
                        className="fleetCarBlock__link"
                        onClick={!!onClick ? () => onClick(car.id) : undefined}
                    >
                        <ShortCarDescription car={car} />
                    </Link>
                )
                : <ShortCarDescription car={car} />
            }
        </div>
    );
};
export const AlertSubBlock = (props: { alertDto: AlertModule.Types.AlertDefinitionDto }) => {
    const {alertDto} = props;
    return (
        <div className="fleetCarBlock">
        <div className="fleetCarBlock__wrapper">
                {alertDto.cars.map((car, i) => (
                    <SingleCarSubComponent key={car.deviceId + car.id} car={car}/>
                ))}
                {alertDto.fleets.map((fleet, i) => {
                    return (
                        <div key={fleet.id} className="fleetCarBlock__single">
                            <div className="fleetCarBlock__img fleetCarBlock__img--bordered">
                                {fleet.numberOfCars} <img src="/images/icons/fleet.svg" alt=""/>
                            </div>
                            <span>{fleet.name}</span>
                        </div>
                    );
                })}
                {alertDto.domainsOfInterest.map((domain, i) => {
                    return (
                        <div key={domain.id} className="fleetCarBlock__single">
                            <div className="fleetCarBlock__img fleetCarBlock__img--domain">
                                <img src={Dictionary.ZoneTypeIcons.get(domain.domainOfInterestType)} alt=""/>
                            </div>
                            <span>{domain.title}</span>
                        </div>
                    );
                })}
                {alertDto.cars.length === 0 && alertDto.domainsOfInterest.length === 0 && alertDto.fleets.length === 0 && (
                    <div className="fleetCarBlock__single">
                        <p className="bold">Brak pojazdów / flot / obszarów w wybranej flocie.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export interface IReactTableWrapper {
    setActiveSorting: (e: any, colId: string, onChange: Function) => void
}

type TerminalInstallationListBlockProps = {
    terminalInstallationLogs: Array<TIModule.Types.TerminalInstallationOrderHistory>;
    unmountCallBack: Function;
    loader: TIModule.TerminalInstallationEnumTypes.HistoryRequestStatus;
    t?: any;
    historyComment: TIModule.Types.TerminalInstallationOrderDto;
    terminalInstallationNotes: Array<TIModule.Types.TerminalInstallationNote>;
    addNote: Function;
    terminalId: number;
};

interface IState {
    noteContent: string
}

class TerminalInstallationListBlockClass extends React.Component<TerminalInstallationListBlockProps, IState> {

    constructor(props) {
        super(props);
        this.state = {
            noteContent: ''
        }
    }

    private renderForEmpty() {
        return (
            <div className="fleetCarBlock__single">
                <p className="bold">Brak Historii</p>
            </div>
        );
    }

    private renderForList() {
        const {terminalInstallationLogs, t} = this.props;

        return terminalInstallationLogs.map((el, i) => {
            if (el.historyEventType === EnumTypes.HistoryEventType.STATUS_CHANGED) {
                if (el.oldStatus) {
                    return (
                        <div key={i} className="fleetCarBlock__single fleetCarBlock__single--full">
                            {moment(el.statusChangeDate).format('HH:mm DD.MM.YYYY')}
                            <img src={Dictionary.TerminalInstalationStatusIcon.get(el.oldStatus)} alt=""
                                 style={{marginLeft: '5px', marginRight: '5px'}}/>({t(`dictionary:${el.oldStatus}`)}) =>
                            <img src={Dictionary.TerminalInstalationStatusIcon.get(el.newStatus)} alt=""
                                 style={{marginLeft: '5px', marginRight: '5px'}}/>({t(`dictionary:${el.newStatus}`)})
                            <span>
                            &nbsp;{t(`tables:by`)} {el.changeAuthorFirstName} {el.changeAuthorLastName}
                        </span>
                        </div>
                    );
                } else {
                    return (
                        <div key={i} className="fleetCarBlock__single fleetCarBlock__single--full">
                        <span>
                            {moment(el.statusChangeDate).format('HH:mm DD.MM.YYYY')} {t(`tables:created_by`)} {el.changeAuthorFirstName} {el.changeAuthorLastName}
                        </span>
                        </div>
                    );
                }
            } else if (el.historyEventType === EnumTypes.HistoryEventType.DATA_CHANGED) {
                return (
                    <div key={i} className="fleetCarBlock__single fleetCarBlock__single--full">
                        {moment(el.statusChangeDate).format('HH:mm DD.MM.YYYY')}
                        <img src="images/icons/edit-sign.svg" alt=""
                             style={{marginLeft: '5px', marginRight: '5px'}}/>{el.changeDescription}
                        &nbsp;{t(`tables:by`)} {el.changeAuthorFirstName} {el.changeAuthorLastName}
                    </div>
                );
            }
        });
    }

    private renderForLoader() {
        return (
            <div className="fleetCarBlock__loaderwrapper">
                <div className="loader__inner loader__inner--sm"/>
            </div>
        );
    }

    private renderForNotes() {
        const {terminalInstallationNotes, t} = this.props;

        return (
            <div className="fleetCarBlock notes">
                <div className="bold">Notatki:</div>
                {terminalInstallationNotes.length > 0 ?
                    <>
                        {terminalInstallationNotes.map((note: TIModule.Types.TerminalInstallationNote) =>
                            <div className="notes__single" key={note.id}>
                                <div className="notes__single-description">
                                    <div className="bold">
                                        {`${note.authorFirstName} ${note.authorLastName}`}
                                    </div>
                                    <div>
                                        {moment(note.creationDate).format('LLL')}
                                    </div>
                                </div>
                                <div className="notes__single-content">
                                    {note.comment}
                                </div>
                            </div>
                        )}
                    </>
                    :
                    <div>
                        Brak notatek
                    </div>}

                <div className="notes__add">
                    <label htmlFor="new-note-input">
                        {t(`forms:addNote`)}
                    </label>
                    <textarea name="new-note" id="new-note-input" className="notes__input" cols={50} rows={3}
                              value={this.state.noteContent}
                              onChange={event => this.setState({noteContent: event.target.value})}/>
                    <button className="btn btn--blue notes__btn"
                            onClick={() => this.props.addNote(this.props.terminalId, this.state.noteContent)}>{t('forms:add')}</button>
                </div>
            </div>
        )
    }

    public render() {
        const {terminalInstallationLogs, loader, historyComment, t} = this.props;
        const historyCommentShow =
            historyComment &&
            (historyComment.carHasDamage || historyComment.compatibleVin === false || historyComment.dashboardHasErrors || historyComment.commentOnCarDamage);
        const isLoader = loader != TIModule.TerminalInstallationEnumTypes.HistoryRequestStatus.HIDDEN;
        const terminalInstallationLogsisNotEmpty = terminalInstallationLogs && terminalInstallationLogs.length > 0;

        if (isLoader) {
            return (
                <div className="fleetCarBlock">
                    <div className="fleetCarBlock__wrapper">{this.renderForLoader()}</div>
                </div>
            );
        } else {
            return (
                <div className="fleetCarBlock">
                    <div className="fleetCarBlock__wrapper">
                        {terminalInstallationLogsisNotEmpty ? (
                            <>
                                {historyCommentShow && (
                                    <div
                                        className="fleetCarBlock__single fleetCarBlock__single--full fleetCarBlock__single--vertical">
                                        {
                                            historyComment.carHasDamage ?
                                                <span>
                                                            <span
                                                                className='bold'>{t(`tables:car_has_damage`)} </span> {historyComment.commentOnCarDamage ? ': ' + historyComment.commentOnCarDamage : ''}
                                                        </span> : ''
                                        }
                                        {
                                            historyComment.dashboardHasErrors &&
                                            <span>
                                                            <span
                                                                className='bold'>{t(`tables:dashboard_has_errors`)} </span> {historyComment.commentOnDashboardErrors ? ': ' + historyComment.commentOnDashboardErrors : ''}
                                                        </span>
                                        }
                                        {historyComment.commentOnInstallation ?
                                            <span>
                                                                <span
                                                                    className='bold'>{t(`tables:installation_comment`)} </span> {historyComment.commentOnInstallation ? ': ' + historyComment.commentOnInstallation : ''}
                                                            </span> : ''
                                        }
                                        {
                                            historyComment.compatibleVin === false &&
                                            <span className='bold'>{t(`tables:incompatible_vin`)}</span>
                                        }
                                    </div>
                                )}
                                {this.renderForList()}
                                {this.renderForNotes()}
                            </>
                        ) : (
                            this.renderForEmpty()
                        )}
                    </div>
                </div>
            );
        }
    }

    public componentWillUnmount() {
        this.props.unmountCallBack();
    }
}

export const TerminalInstallationListBlock = withTranslation(['forms', 'tables', 'dictionary'])(TerminalInstallationListBlockClass as React.ComponentType<any>);

export const OnOff = (props: { isOn: boolean; onClick: (value: boolean) => void, e2eId?: string }) => (
    <div className="switcher">
        <div className={`switcher__inner ${props.isOn ? 'switcher__inner--active' : ''}`}
             onClick={() => props.onClick(props.isOn)} date-e2eid={(props.e2eId) ? props.e2eId : null}>
            <div className={`switcher__indicator ${props.isOn ? 'switcher__indicator--active' : ''}`}/>
        </div>
    </div>
);

export const ContractHistoryList = withTranslation(['forms', 'tables', 'dictionary'])(
    class ContractHistoryListClass extends React.Component<{ history: Array<Types.ContractHistoryDto>, t?: Function }> {
        public render() {
            const {history} = this.props;
            return <div className="sub-content" data-testid="history-sub-content">
                <h3 className="main__title"> Historia zmian umowy
                    nr. {this.props.history[history.length - 1]?.contractNumber}</h3>
                {this.props.history?.length > 0 ? <ReactTable
                    className="table pure-table"
                    data={this.props.history}
                    filterable={false}
                    sortable={false}
                    columns={this.columns}
                    pageSize={1}
                /> : <div>
                    Brak danych do wyświetlenia
                </div>}
            </div>
        }

        private columns = [
            {
                id: 'active',
                accessor: 'active',
                Header: this.props.t('contractStatus'),
                className: 'cell',
                maxWidth: 120,
                Cell: ({value}) => this.props.t(`tables:${value ? ActiveType.ACTIVE : ActiveType.NOT_ACTIVE}`),
            },
            {
                Header: this.props.t('executionStatus'),
                id: 'executionStatus',
                accessor: 'executionStatus',
                className: 'cell copyable',
                Cell: ({value}) => this.props.t(`tables:${value}`)
            },
            {
                id: 'contractNumber',
                accessor: 'contractNumber',
                Header: 'Nr. umowy',
                className: 'cell',
            },
            {
                id: 'vin',
                accessor: 'vin',
                Header: 'VIN',
                className: 'cell',
            },
            {
                id: 'plannedEndDate',
                accessor: 'plannedEndDate',
                Header: this.props.t('plannedEndDate'),
                className: 'cell',
                Cell: ({value}) => value ? moment(value).format('DD.MM.YYYY') : '-'

            },
        ];
    } as React.ComponentType<any>
);

export const NotifyCell = (props: any) => {
    const {notifyData} = props;
    return (
        <p title={notifyData.value}>
            <span className="col__icons">
                <i className={`icon mr-10 icon--email ${notifyData.original.notifyByEmail ? '' : 'icon--lighter'}`}/>
                <i className={`icon mr-10 icon--system-notification ${notifyData.original.notifyBySystemNotification ? '' : 'icon--lighter'}`}/>
            </span>
            {notifyData.value.substr(0, 60)}
            {notifyData.value.length > 60 ? '...' : ''}
        </p>
    );
};

export const UserStatus = ({userData, t}) => {
    return (
        <div className="flex flex--center">
            <img src={Dictionary.UserStatusIcon.get(userData.value)} alt={userData.value} width={18}
                 className="mr-7"/>
            <span>{t(`dictionary:${userData.value}`)}</span>
        </div>
    );
};

export namespace Filter {

    export class TypingDetection<T extends (...args: any[]) => ReturnType<T>> {
        private typedValue;
        private typingTimeout = null;
        private delay: number;
        private onChangeFunction: T;

        constructor(_delay: number = 500, _onChangeFunction: T) {
            this.delay = _delay;
            this.onChangeFunction = _onChangeFunction;
        }

        public detectFinish(event) {
            this.typedValue = event.target.value;
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(() => this.onChangeFunction(this.typedValue), this.delay);
        }
    }

    export const InputTextFilter = function (placeholder: string, withSort: boolean, {filter, onChange, column, _typingDetector = null, defaultInput = ''}) {
        const typingDetector = _typingDetector ? _typingDetector : new TypingDetection(500, onChange);
        return (
            <div className="">
                <input
                    type="text"
                    data-id="id"
                    placeholder={placeholder}
                    className="filter__input"
                    defaultValue={defaultInput || ''}
                    onChange={event => {
                        typingDetector.detectFinish(event);
                    }}
                />
                {withSort && <CustomSort
                    onChange={e => {
                        this.setActiveSorting(e, column.id, onChange)
                    }}
                    value={filter ? filter.value : ''}
                    isActive={this.state.activeSorting === column.id}
                />}
            </div>
        )
    }

    // Powielam ten filtr by nie ugrząźć na zawsze w tym bajorze
    export const InputTextFilterWithRef = function (innerRef, placeholder: string, withSort: boolean, {filter, onChange, column, _typingDetector = null, defaultInput = ''}) {
        const typingDetector = _typingDetector ? _typingDetector : new TypingDetection(500, onChange);
        return (
            <div className="">
                <input
                    ref={innerRef}
                    type="text"
                    data-id="id"
                    placeholder={placeholder}
                    className="filter__input"
                    defaultValue={filter?.value || defaultInput || ''}
                    onChange={event => {
                        typingDetector.detectFinish(event);
                    }}
                />
                {withSort && <CustomSort
                    onChange={e => {
                        this.setActiveSorting(e, column.id, onChange)
                    }}
                    value={filter ? filter.value : ''}
                    isActive={this.state.activeSorting === column.id}
                />}
            </div>
        )
    }

    export const speedSorting = function (placeholder: string, {filter, onChange, column, _typingDetector = null}) {
        return (
            <div className="flex flex--center flex--justify-center">
                <div className="icon icon--speed mr-7"
                    // onClick={e => {
                    //     this.setActiveSorting(e, column.id, onChange)
                    // }}
                />
                <CustomSort
                    className="filter__sort--speed"
                    iconClass="filter__sort-icon--speed"
                    onChange={e => {
                        this.setActiveSorting(e, column.id, onChange)
                    }}
                    value={filter ? filter.value : ''}
                    isActive={this.state.activeSorting === column.id}
                />
            </div>
        )
    }

    // TODO: jak powróci infinityScrollTable to to może nie działać. Ważna kolejność paramentrów przekazanych z tej funkcji do InputTextFilter
    export const CustomInputTextFilter = function (placeholder: string, customOnChange, tableObject) {
        const typingDetector = new TypingDetection(500, customOnChange);
        return InputTextFilter.call(this, placeholder, {tableObject, _typingDetector: typingDetector}); //TODO: jak powyżej -> sprawdzić czy takie rozwiązanie będzie ok
    }

    export const InputTextWithDefaultValue = function (placeholder, defaultInput, filterParameters) {
        return InputTextFilter.call(this, placeholder, true, {...filterParameters, defaultInput});
    }

    export const SortFilter = function (placeholder: string, {filter, onChange, column}) {
        return (
            <div className="filter__title" title={placeholder}>
                <span>{placeholder}</span>
                <CustomSort
                    onChange={e => {
                        this.setActiveSorting(e, column.id, onChange)
                    }}
                    value={filter ? filter.value : ''}
                    isActive={this.state.activeSorting === column.id}
                />
            </div>
        )
    }

    export const TooltipFilter = function (placeholder: string, {column, filter, onChange}) {
        return (
            <div className="flex flex--center">
                <TooltipFiltering
                    optionList={this.optionList}
                    isActive={this.state.activeFilter === column.id}
                    value={filter ? filter.value : ''}
                    label={placeholder}
                    toggleOpen={() => {
                        this.setState({activeFilter: this.state.activeFilter === column.id ? '' : column.id});
                    }}
                    onChange={e => onChange(e)}
                />
                <div className="tool-filter__title">{placeholder}</div>
            </div>
        )
    }

    export const FilterSortingFix = function (activeFilters: Array<{ id: string; value: any }>) {

        // wartość filtru ze stanu reacttable
        const filterValue = activeFilters.find(element => element.id === this.state.activeSorting);

        // jeśli jest ustawione sortowanie z kluczem takim samym jak ustawiony już filtr oraz value tego obiektu jest rodzaju sortowania (desc/asc)
        if (filterValue && ['DESCENDING', 'ASCENDING'].indexOf(filterValue?.value) !== -1) {
            // sprawdzam czy już jest zaznaczone to filtrowanie (to widoczne jest tylko w lokalnym stanie)
            // this.state jest możliwe bo przy wywołaniu przekazuję odpowiedni context
            const sortingFilter = activeFilters.find(element => element.id === `sort_${this.state.activeSorting}`);
            const inputFilterValue = this.state.activeFilters.find(element => element.id === this.state.activeSorting);

            if (sortingFilter) {
                // jeśli tak to przypisuję mu aktualnie przypisaną wartość asc/desc
                sortingFilter.value = filterValue.value;
            } else {
                // jeśli nie to tworzę nowe pole z przedrostkiem 'sort_' jeśli nie istnieje jeszcze pole o tym kluczu
                const sortEntryElementId = activeFilters.findIndex(element => element.id.match(/^sort_/g));

                if (sortEntryElementId === -1) {
                    activeFilters.push({id: `sort_${filterValue.id}`, value: filterValue.value});
                } else {
                    // lub nadpisuję istniejące nowymi wartościami jeśli istnieje
                    activeFilters[sortEntryElementId].id = `sort_${filterValue.id}`;
                    activeFilters[sortEntryElementId].value = filterValue.value;
                }
            }
            // jako, że to pole jest błędnie uzupełnione wartością asc/desc to przypisuję spowrotem wartość pola z lokalnego stanu
            filterValue.value = inputFilterValue?.value;
        }
    };
}

export namespace Cell {
    export const HeaderTextCell = text => {
        return (
            <span title={text}>{text}</span>
        );
    }

    export const CutTextCell = (props, callback) => {
        return (
            <div className="cell__cut-text overflow-wrapper"
                 onClick={() => copyToClipboard(props.value, callback)}>
                <span title={props.value} className="cell__title">
                    {props.value}
                </span>
            </div>
        );
    }

    export const CutDataTextCall = (props, callback = null) => {
        const dateString = (props.value) ? moment(props.value).format('DD.MM.YYYY') : '-';
        return Cell.CutTextCell({value: dateString}, callback)
    }

    export const carManufacturerOrModelCell = (props, callback) => {
        const carName = (props.original.carManufacturer && props.original.carModel) ? `${props.original.carManufacturer} ${props.original.carModel}` : '-';
        return (
            <div className="cell__cut-text overflow-wrapper"
                 onClick={() => copyToClipboard(carName, callback)}>
                <span title={carName} className="cell__title">
                    {carName}
                </span>
            </div>
        );
    }

    export const CutFirstLastName = (props, callback) => {
        const name = props.value ? `${props.value.firstName} ${props.value.lastName}` : '-';
        return (
            <div className="cell__cut-text overflow-wrapper" onClick={() => copyToClipboard(name, callback)}>
                <span title={name} className="cell__title">
                    {name}
                </span>
            </div>
        );
    }

    export const GetTechnicianFullName = (props, callback) => {
        let name = props.original ? `${props.original.technicianFirstName || '-'} ${props.original.technicianLastName || '-'}` : '-';
        name = name === '- -' ? '-' : name;
        return (
            <div className="cell__cut-text overflow-wrapper" onClick={() => copyToClipboard(name, callback)}>
                <span title={name} className="cell__title">
                    {name}
                </span>
            </div>
        );
    }

    export const Expander = (expanderInfo: any) => {
        return (
            <>
                <div className={`cell__expander ${expanderInfo.isExpanded ? 'cell__expander--expanded' : ''}`}/>
                {expanderInfo.original.hasComments && <div className="cell__has-notes"/>}
            </>
        )
    }
    export const RegularFilter = (filterInfo: any, placeholder?: string, className: string = '', _typingDetector = null) => {
      const typingDetector = _typingDetector ? _typingDetector : new Filter.TypingDetection(500, filterInfo.onChange);

      return (
        <input
          className={`filter__input ${className}`}
          type="text"
          data-id="name"
          defaultValue={filterInfo.filter?.value}
          placeholder={placeholder}
          onChange={event => {
            typingDetector.detectFinish(event);
          }}
        />
      );
    };
    export const Fleet = (props: any): React.ReactNode => {
        return (
            <div className="flex flex--center">
                <div className="cell__fleet-icon">
                    <span className="font-bold font-blue">{props.original.numberOfCars}</span>
                    <img src="/images/icons/fleet.svg" alt="Liczba pojazdów" width={20}/>
                </div>
                <span>{props.value}</span>
            </div>
        );
    };
    export const Date = (props: { value: string }) => {
        return moment(props.value).format('HH:mm:ss, DD.MM.YYYY');
    };

    export const CutAddress = (props, callback) => {
        if (props.value) {
            const title = `${props.value.streetName} ${props.value.houseNo} ${props.value.postCode} ${props.value.city}`;
            return (
                <div className="cell__cut-text overflow-wrapper"
                     onClick={() => copyToClipboard(title, callback)}>
                    <span title={title} className="cell__title">
                        {title}
                    </span>
                </div>
            );
        } else {
            return null;
        }
    }

    export const Acceleration = (props: any): React.ReactNode => {
        if (props.value) {
            return (
                <span title={`${props.value * 9.81}`}>
                    {Cell.Number({value: props.value * 9.81, toFixedNo: props.toFixedNo})} m/s<sup>2</sup>
                </span>
            );
        } else {
            // return null;
            return (
                <span title='0'>
                    0 m/s<sup>2</sup>
                </span>
            );
        }
    };
    export const Number = (props: { value: number; toFixedNo?: number }) => props.value.toFixed(props.toFixedNo ? props.toFixedNo : 3);
    export const LatLng = (props: { original: any }) => {
        if (props.original && props.original.latitude) {
            return (
                <span>
                    {Cell.Number({
                        value: props.original.latitude,
                        toFixedNo: 4
                    })}, {Cell.Number({value: props.original.longitude, toFixedNo: 4})}
                </span>
            );
        } else {
            return null;
        }
    };
    export const Heading = (props: { value: number }) => convertHeadingIntoText(props.value);

    const copyToClipboard = (text, copiedCallback = null) => {
        try {
            if (copiedCallback !== null && typeof copiedCallback === "function") {
                const el = document.createElement('textarea');
                el.value = text;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                copiedCallback(text);
            }
        } catch (e) {
            console.log(e);
        }
    }
}

interface IInfiniteTableForDataframesSFCParams extends WithTranslation {
  listData: VehiclesModule.Types.CarDataframeDto[]
  onRowClick: (dataframe: VehiclesModule.Types.CarDataframeDto) => void
  activeDataframeID: VehiclesModule.Types.CarDataframeDto
  onFetchData?: TableProps['onFetchData']
  totalCount: number
  innerRef?: LegacyRef<ReactTable<VehiclesModule.Types.CarDataframeDto>>
  manual?: boolean
}

const InfiniteTableForDataframesSFC = ({
  onFetchData,
  t,
  activeDataframeID,
  listData,
  onRowClick,
  totalCount,
  innerRef,
  manual = true
}: IInfiniteTableForDataframesSFCParams) => {
    return (
        <div className="table__content">
            <ReactTable
                ref={innerRef}
                manual={manual}
                data={listData ?? []}
                showPagination={true}
                defaultPageSize={DEFAULT_PAGE_SIZE_FOR_HISTORY}
                pageSize={DEFAULT_PAGE_SIZE_FOR_HISTORY}
                pages={Math.ceil(totalCount / DEFAULT_PAGE_SIZE_FOR_HISTORY)}
                getTheadThProps={injectThProps}
                getTrProps={(state, rowInfo, column) => {
                    let className = '';
                    if (rowInfo && rowInfo.original && activeDataframeID) {
                        className = rowInfo.original.id === activeDataframeID.id ? 'active' : '';
                    }
                    return {
                        className,
                        onClick: () => {
                            onRowClick(rowInfo.original);
                        }
                    };
                }}
                onFetchData={onFetchData}
                columns={[
                    {
                        Header: 'hiddenHeader',
                        id: 'dateTime',
                        accessor: 'dateTime',
                        width: 130,
                        Filter: () => <div className="filter__title">{t('dateTime')}</div>,
                        Cell: Cell.Date
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'longitude',
                        accessor: 'longitude',
                        width: 105,
                        Filter: () => <div className="filter__title">{t('latLng')}</div>,
                        Cell: Cell.LatLng
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'acceleration',
                        accessor: 'acceleration',
                        width: 90,
                        Filter: () => <div className="filter__title">{t('acceleration')} [g]</div>,
                        Cell: Cell.Number
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'heading',
                        accessor: 'heading',
                        width: 80,
                        Filter: () => <div className="filter__title">{t('heading')}</div>,
                        Cell: Cell.Heading
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'satellite',
                        accessor: 'satellite',
                        width: 50,
                        Filter: () => <div className="filter__title">{t('satellite')}</div>
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'speedGps',
                        accessor: 'speedGps',
                        width: 65,
                        Filter: () => <div className="filter__title">{t('speedGps')} [km/h]</div>
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'address',
                        accessor: 'address',
                        Filter: () => <div className="filter__title">{t('address')}</div>
                    }
                ]}
            />
        </div>
    );
};

export const InfiniteTableForDataframes = withTranslation('carDetails')(InfiniteTableForDataframesSFC);



// WEBPACK FOOTER //
// ./src/HelperFunctions/Lists.tsx